import { getShippingTime } from '@api/api'
import { queryOptions } from '@tanstack/react-query'

const SHIPPING_TIME_QUERY = 'SHIPPING_TIME'

export const shippingTimeQueryOptions = queryOptions({
  queryKey: [SHIPPING_TIME_QUERY],
  queryFn: async () => {
    const res = await getShippingTime()
    return res.data.data
  },
})
